import { makeStyles } from "tss-react/mui";

export const useRecommendedFeaturesSectionStyles = makeStyles()(() => ({
  root:{
    display:"flex",
    flexDirection:"column",
    aligItems: "flex-start",
    alignSelf: "stretch",
    gap: "1rem",
    paddingRight: "1px",
    paddingLeft: "1px",
    height:"31.94%",
    "@media(min-width: 1536px)": {
      height:"31.21%"
    },
    "@media(min-width: 1920px)": {
      height:"31.37%"
    }
  },
  title:{
    fontSize: "1.5rem",
    fontWeight: 500,
    letterSpacing: "0%",
    color:"var(--color-neutral-600)",
  },
  features:{
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: "1.996875rem",
    alignSelf: "stretch",
    "@media(min-width: 1536px)": {
      gap: "2.0625rem",
    },
    "@media(min-width: 1920px)": {
      gap: "2.625rem",
    },
  }
}));
